import { Theme } from "@mui/material";
import { z } from "zod";

export enum RequestStateTypeEnum {
    ROZPRACOVANA = 1,
    ULOZENA = 2,
    ODOSLANA_NA_SPRACOVANIE = 3,
    RIESI_SA = 4,
    CAKA_SA_NA_NIEKOHO = 5,
    NEOPODSTATNENA = 6,
    VYBAVENA = 7,
    VYBAVENA_A_POSLANA_NA_DALSIU_CINNOST = 8,
    ZRUSENA_A_NAHRADENA_INOU_CINNOSTOU = 9,
    ODOSLANA_NA_PODPIS = 10,
    ZIADOST_PODPISANA_RUCNE = 11,
    LINK_ODOSLANY_EMAILOM = 12,
    LINK_ODOSLANY_SMS = 13,
    POTVRDENIE_ZRUSENE = 14,
    LINK_POTVRDENY_KLIENTOM = 15
}

export const RequestStateTypeEnumSchema = z.nativeEnum(RequestStateTypeEnum);
export type RequestStateTypeEnumSchema = z.infer<typeof RequestStateTypeEnumSchema>;

export const getTextColor = (value: RequestStateTypeEnum, theme: Theme): string => {
    switch (value) {
        case RequestStateTypeEnum.VYBAVENA:
        case RequestStateTypeEnum.VYBAVENA_A_POSLANA_NA_DALSIU_CINNOST:
            return theme.palette.success.main;
        case RequestStateTypeEnum.ZRUSENA_A_NAHRADENA_INOU_CINNOSTOU:
        case RequestStateTypeEnum.NEOPODSTATNENA:
            return theme.palette.error.main;
        case RequestStateTypeEnum.ROZPRACOVANA:
        case RequestStateTypeEnum.ODOSLANA_NA_SPRACOVANIE:
        case RequestStateTypeEnum.RIESI_SA:
        case RequestStateTypeEnum.CAKA_SA_NA_NIEKOHO:
        case RequestStateTypeEnum.ULOZENA:
        case RequestStateTypeEnum.ODOSLANA_NA_PODPIS:
        case RequestStateTypeEnum.ZIADOST_PODPISANA_RUCNE:
        case RequestStateTypeEnum.LINK_ODOSLANY_EMAILOM:
        case RequestStateTypeEnum.LINK_ODOSLANY_SMS:
        case RequestStateTypeEnum.LINK_POTVRDENY_KLIENTOM:
        case RequestStateTypeEnum.POTVRDENIE_ZRUSENE:
            return theme.palette.success.main;
        default:
            return theme.palette.text.primary;
    }
}
